module.exports = __webpack_public_path__ + "static/media/julius.53ea2b84.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/julius.jpeg
// module id = 43
// module chunks = 0